function tooltips(){
    let mapPhones = document.querySelectorAll('.map__office__phone');
    if(!mapPhones.length) return;
    mapPhones.forEach((item) => {
        item.addEventListener('click', () => {
            item.querySelector('.tooltip-link').classList.toggle('d-none');
        });
    });

}
export default {tooltips};